"use strict";

exports.__esModule = true;
var fetchIsFulfilled = function fetchIsFulfilled(prevProps, nextProps, resource) {
  return prevProps[resource + "Fetch"] && nextProps[resource + "Fetch"] && prevProps[resource + "Fetch"].pending && nextProps[resource + "Fetch"].fulfilled;
};

exports.default = {
  fetchIsFulfilled: fetchIsFulfilled
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-redux-fetch/lib/utils/componentHelpers.js
// module id = 688
// module chunks = 0